import { render, staticRenderFns } from "./choiceConsumable.vue?vue&type=template&id=04c75ab5&scoped=true&"
import script from "./choiceConsumable.vue?vue&type=script&lang=js&"
export * from "./choiceConsumable.vue?vue&type=script&lang=js&"
import style0 from "./choiceConsumable.vue?vue&type=style&index=0&id=04c75ab5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c75ab5",
  null
  
)

export default component.exports